// SoonToExpireDrugsReport.jsx
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import config from "../../Helpers/config";
import { errorMessages} from "../../Helpers/ErrorMessages";
import { titleCase } from "../../Utils/titleCaseFunction";
import ReusableDashboardHeader from "../../Containers/Dasboard/ReusableDashboardHeader";
import { Container } from "../../Utils/styledComponents";
import { BackButton } from "../../Utils/FormInputs/BackButton";
import { formatDigits } from "../../Utils/formatAmount";
import { MuiPaper, EnhancedTableHead, EnhancedTableToolbar } from "../../Utils/Tables/CustomTable";
import { useExcelReports, usePdfReports } from "../Invoice/CustomHooks/useExcelReports";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as snackbarActions from "../../Redux/Actions/SnackbarActions/SnackbarActions";
import PharmacySnackbar from "../../Utils/Snackbars/SnackbarUtil";

const headData = [
  { id: "product_name", label: "Product Name", align: "left" },
  { id: "generic_name", label: "Generic Name", align: "left" },
  { id: "strength", label: "Strength", align: "left" },
  { id: "batch_number", label: "Batch No", align: "center" },
  { id: "expiry_date", label: "Expiry Date", align: "center" },
  { id: "days_remaining", label: "Days Left", align: "center" },
  { id: "quantity", label: "Stock Qty", align: "center" },
  { id: "total_value_ugx", label: "Value at Cost (UGX)", align: "right" },
  { id: "location", label: "Location", align: "left" },
];

const SoonToExpireDrugsReport = ({ actions, snackbars }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [summary, setSummary] = useState({
    total_drugs_expiring: 0,
    total_value_at_cost: 0,
    critical_items_30days: 0,
  });
  const [daysFilter, setDaysFilter] = useState(90);

  const { open, message, variant } = snackbars;

  const fetchData = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await axios.get(`${config.epharmUrl}/Creport/soon_to_expire_drugs`, {
        params: { days: daysFilter },
        timeout: 15000,
      });

      if (res.data?.success) {
        setData(res.data.data || []);
        setSummary(res.data.summary || summary);
      } else {
        throw new Error(res.data?.message || "Failed to fetch data");
      }
    } catch (err) {
      const msg = err.response?.data?.message || err.message || "Network error";
      setError(msg);
      actions.snackbarActions.errorSnackbar(msg);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [daysFilter]);

  // Export configs
  const excelObj = {
    file_name: `Soon-to-Expire Drugs (${daysFilter} days)`,
    url: "Creport/soon_to_expire_drugs_excel",
    params: { days: daysFilter },
  };
  const pdfObj = {
    file_name: `Soon-to-Expire Drugs (${daysFilter} days)`,
    url: "Creport/soon_to_expire_drugs_pdf",
    params: { days: daysFilter },
  };

  const { exportExcel } = useExcelReports(actions, excelObj);
  const { exportPDF } = usePdfReports(actions, pdfObj);

  const getRowColor = (days) => {
    if (days <= 30) return "#ffebee";
    if (days <= 60) return "#fff3e0";
    return "#e8f5e8";
  };

  const getBadge = (days) => {
    if (days <= 30)
      return <span className="badge badge-pill badge-danger font-weight-bold">CRITICAL</span>;
    if (days <= 60)
      return <span className="badge badge-pill badge-warning text-dark font-weight-bold">WARNING</span>;
    return <span className="badge badge-pill badge-success font-weight-bold">SAFE</span>;
  };

  return (
    <>
      <ReusableDashboardHeader
        component="Soon-to-Expire Drugs Report"
        heading="Pharmacy"
        subHeading="Real-time monitoring of drugs nearing expiry"
        link="/allreports"
      />

      <PharmacySnackbar
        open={open}
        message={message}
        variant={variant}
        handleCloseBar={() => actions.snackbarActions.hideSnackBar()}
      />

      <Container>
        <div className="mb-3">
          <BackButton text="Back to Reports" to="/allreports" />
        </div>

        {/* Modern Summary Cards */}
        {/* Modern Summary Cards – NOW 100% VISIBLE TEXT */}
<div className="row mb-4">
  <div className="col-lg-4 mb-3">
    <div className="card border-0 shadow-lg text-white" style={{background: 'linear-gradient(135deg, #dc3545, #c82333)'}}>
      <div className="card-body text-center py-5">
        <i className="fa fa-exclamation-triangle fa-3x mb-3"></i>
        <h6 className="mb-3 text-white" style={{fontSize: '1.1rem', fontWeight: 600, textShadow: '1px 1px 3px rgba(0,0,0,0.6)'}}>
          CRITICAL ITEMS (&lt; 30 DAYS)
        </h6>
        <h1 className="mb-0 display-4 font-weight-bold" style={{textShadow: '2px 2px 8px rgba(0,0,0,0.7)'}}>
          {summary.critical_items_30days}
        </h1>
      </div>
    </div>
  </div>

  <div className="col-lg-4 mb-3">
    <div className="card border-0 shadow-lg text-white" style={{background: 'linear-gradient(135deg, #fd7e14, #e76a00)'}}>
      <div className="card-body text-center py-5">
        <i className="fa fa-prescription-bottle-alt fa-3x mb-3"></i>
        <h6 className="mb-3 text-white" style={{fontSize: '1.1rem', fontWeight: 600, textShadow: '1px 1px 3px rgba(0,0,0,0.6)'}}>
          TOTAL ITEMS AT RISK
        </h6>
        <h1 className="mb-0 display-4 font-weight-bold" style={{textShadow: '2px 2px 8px rgba(0,0,0,0.7)'}}>
          {summary.total_drugs_expiring}
        </h1>
        <small className="text-white opacity-9" style={{fontSize: '1rem'}}>
          In the next {daysFilter} days
        </small>
      </div>
    </div>
  </div>

  <div className="col-lg-4 mb-3">
    <div className="card border-0 shadow-lg text-white" style={{background: 'linear-gradient(135deg, #343a40, #212529)'}}>
      <div className="card-body text-center py-5">
        <i className="fa fa-money-bill-wave fa-3x mb-3"></i>
        <h6 className="mb-3 text-white" style={{fontSize: '1.1rem', fontWeight: 600, textShadow: '1px 1px 3px rgba(0,0,0,0.8)'}}>
          TOTAL VALUE AT RISK
        </h6>
        <h1 className="mb-0 display-4 font-weight-bold" style={{textShadow: '2px 2px 8px rgba(0,0,0,0.9)'}}>
          UGX {formatDigits(summary.total_value_at_cost)}
        </h1>
      </div>
    </div>
  </div>
</div>
        {/* <div className="row mb-4">
          <div className="col-lg-4 mb-3">
            <div className="card border-0 shadow-sm text-white bg-gradient-danger">
              <div className="card-body text-center py-4">
                <h6 className="mb-2 opacity-8">Critical Items</h6>
                <h2 className="mb-0">{summary.critical_items_30days}</h2>
                <small>Expiring in less than or equal to 30 days</small>
              </div>
            </div>
          </div>

          <div className="col-lg-4 mb-3">
            <div className="card border-0 shadow-sm text-white bg-gradient-warning">
              <div className="card-body text-center py-4">
                <h6 className="mb-2 opacity-8">Total Items at Risk</h6>
                <h2 className="mb-0">{summary.total_drugs_expiring}</h2>
                <small>In the next {daysFilter} days</small>
              </div>
            </div>
          </div>

          <div className="col-lg-4 mb-3">
            <div className="card border-0 shadow-sm text-white bg-gradient-dark">
              <div className="card-body text-center py-4">
                <h6 className="mb-2 opacity-8">Total Value at Risk</h6>
                <h2 className="mb-0">UGX {formatDigits(summary.total_value_at_cost)}</h2>
                <small>Cost price of expiring stock</small>
              </div>
            </div>
          </div>
        </div> */}

        <MuiPaper className="shadow-sm">
          {/* Top Bar – Filter + Export */}
          <div className="d-flex flex-wrap justify-content-between align-items-center p-3 border-bottom bg-light">
            <div className="d-flex align-items-center">
              <h5 className="mb-0 text-primary font-weight-bold">
                Soon-to-Expire Drugs List
              </h5>
              <span className="ml-3 badge badge-info badge-pill">
                Next {daysFilter} days
              </span>
            </div>

            <div className="d-flex align-items-center mt-2 mt-md-0">
              <select
                className="form-control form-control-sm mr-3"
                value={daysFilter}
                onChange={(e) => setDaysFilter(Number(e.target.value))}
                style={{ minWidth: "140px" }}
              >
                <option value={7}>7 Days</option>
                <option value={14}>14 Days</option>
                <option value={30}>30 Days</option>
                <option value={60}>60 Days</option>
                <option value={90}>90 Days</option>
              </select>

              <button onClick={exportExcel} className="btn btn-success btn-sm mr-2">
                <i className="fa fa-file-excel mr-1"></i> Excel
              </button>
              <button onClick={exportPDF} className="btn btn-danger btn-sm">
                <i className="fa fa-file-pdf mr-1"></i> PDF
              </button>
            </div>
          </div>

          {/* Table */}
          <div className="table-responsive">
            <table className="table table-hover table-sm align-middle">
              <EnhancedTableHead headCells={headData} />
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan={9} className="text-center py-5">
                      <div className="spinner-border text-primary" role="status">
                        <span className="sr-only">Loading...</span>
                      </div>
                    </td>
                  </tr>
                ) : error ? (
                  <tr>
                    <td colSpan={9} className="text-center text-danger py-5">
                      <i className="fa fa-exclamation-triangle fa-2x mb-3"></i>
                      <br />
                      {error}
                    </td>
                  </tr>
                ) : data.length === 0 ? (
                  <tr>
                    <td colSpan={9} className="text-center text-success py-5">
                      <i className="fa fa-check-circle fa-3x mb-3 text-success"></i>
                      <h5>No drugs expiring in the next {daysFilter} days</h5>
                    </td>
                  </tr>
                ) : (
                  data.map((item, idx) => (
                    <tr
                      key={idx}
                      style={{ backgroundColor: getRowColor(item.days_remaining) }}
                      className="border-left border-right"
                    >
                      <td>
                        <Link
                          to={`/medicinedetails/${item.product_id || "#"}`}
                          className="text-decoration-none font-weight-bold text-primary"
                        >
                          {titleCase(item.product_name)}
                        </Link>
                      </td>
                      <td>{item.generic_name || "—"}</td>
                      <td>{item.strength || "—"}</td>
                      <td className="text-center">
                        <strong>{item.batch_number}</strong>
                      </td>
                      <td className="text-center">{item.expiry_date}</td>
                      <td className="text-center">
                        <strong>{item.days_remaining} days</strong>
                        <br />
                        {getBadge(item.days_remaining)}
                      </td>
                      <td className="text-center font-weight-bold">{formatDigits(item.quantity)}</td>
                      <td className="text-right font-weight-bold text-danger">
                        {formatDigits(item.total_value_ugx)}
                      </td>
                      <td>{item.location || "Main Store"}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* Footer Total */}
          {data.length > 0 && (
            <div className="p-3 bg-danger text-white text-right font-weight-bold">
              TOTAL VALUE AT RISK: UGX {formatDigits(summary.total_value_at_cost)}
            </div>
          )}
        </MuiPaper>
      </Container>
    </>
  );
};

const mapStateToProps = (state) => ({
  snackbars: state.snackbars,
});

const mapDispatchToProps = (dispatch) => ({
  actions: {
    snackbarActions: bindActionCreators(snackbarActions, dispatch),
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(SoonToExpireDrugsReport);